import { introbg, bg2 } from "../../assets";

const introimagedata = [
    {
        background: [{bgImage: introbg}, {bgImage: bg2}]
    }
]

export default introimagedata;